import { realEstateAgentHref } from "@/lib/realEstateAgentHref"
import { realEstateOfficeHref } from "@/lib/realEstateOfficeHref"
import { slugify } from "@/utils/slugify"
import type {
  AgentAutocompleteResult,
  CityAutocompleteResult,
  EntityType,
  OfficeAutocompleteResult,
} from "@/types/entitySearch"
import { embedPaths } from "./paths"

export function buildAgentHrefFromAutocomplete(
  agent: AgentAutocompleteResult
): string | null {
  return realEstateAgentHref({
    displayName: agent.MemberFullName ?? "",
    uniqueListingIdHash: agent.UniqueListingIdHash,
    officeCity: agent.OfficeMetadata?.OfficeCity,
    officeStateOrProvince: agent.OfficeMetadata?.OfficeStateOrProvince,
  })
}

export function buildOfficeHrefFromAutocomplete(
  office: OfficeAutocompleteResult
): string | null {
  return realEstateOfficeHref({
    displayName: office.OfficeName ?? "",
    uniqueListingIdHash: office.UniqueListingIdHash,
    officeCity: office.OfficeCity,
    officeStateOrProvince: office.OfficeStateOrProvince,
  })
}

export function buildCityAgentsHref(city: CityAutocompleteResult): string {
  return embedPaths.realEstateAgentsByLocation(slugify(city.DisplayName))
}

export function buildCityOfficesHref(city: CityAutocompleteResult): string {
  return embedPaths.realEstateOfficesByLocation(slugify(city.DisplayName))
}

export function buildEntityRosterHref(
  type: EntityType,
  value?: string
): string {
  const trimmed = value?.trim()
  const route =
    type === "agent"
      ? embedPaths.realEstateAgents()
      : embedPaths.realEstateOffices()
  return trimmed ? `${route}?value=${encodeURIComponent(trimmed)}` : route
}
